import React from "react";
import { useOutletContext, useParams } from "react-router-dom"; // allows passing data in from parent, essential for this component

import PropTypes from "prop-types";

import "./projects.css";

const Overviewmobile = (props) => {
  var params = useParams();
  return (

						  Object.entries(props.data).map(([id, entry]) => (
								  <div className="overview-container-mobile">
										  <h1 className="overview-title Body-L">{entry.date}: {entry.title}</h1>
										  <span className="overview-text Body-M">{entry.overview}</span>
										  <br /><br />
										  <div className="overview-gallery">
												  <img src={entry.image1} className="overview-image1" />
												  <img src={entry.image2} className="overview-image2" />
												  <img src={entry.image3} className="overview-image3" />
												  <img src={entry.image4} className="overview-image4" />
										  </div>
								  </div>

						  ))
  );
};

Overviewmobile.defaultProps = {
  rootClassName: "",
  title: "Title",
  text: "Synopsis",
  imageId: "",
  imageId1: "",
};

Overviewmobile.propTypes = {
  rootClassName: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  imageId: PropTypes.string,
  imageId1: PropTypes.string,
};

export default Overviewmobile;
